export interface ISliderProps {
	min?: number;
	max?: number;
	value: number;
	disabled?: boolean;
	step?: number;
	width?: number;
	onChange: (newValue: number) => void;
	valueInput?: boolean;
	center?: boolean;
}

export const getSliderStyles = (
	value: number,
	min: number,
	max: number,
	width: number,
	center?: boolean,
) => {
	const styles: React.CSSProperties = {};
	const totalRange = max - min;
	const threshold = 1 - 10 / width;

	if (center) {
		const rangeCenter = (min + max) / 2;
		const percentFromCenter =
			((value - rangeCenter) / (totalRange / 2)) * (width / 2);

		if (value < rangeCenter) {
			styles.left = width / 2 - Math.abs(percentFromCenter) * threshold + 2;
			styles.width = Math.abs(percentFromCenter) * threshold + 1;
		} else {
			styles.left = '50%';
			styles.width = Math.abs(percentFromCenter) * threshold;
		}

		return styles;
	}

	styles.left = 0;
	styles.width = ((value - min) / totalRange) * width * threshold + 10;
	return styles;
};
